<template>
  <div class="itemsRow">

    <!--        <div>-->
    <!--            <v-img :src="imgSource"></v-img>-->
    <!--        </div>-->


    <div class="isection d-flex" v-if="item.section">
      <div class="prefix" v-if="item.sectionContent.indexOf('data-prefix') !== -1">
        <v-icon large class="myAccent mr-1">mdi-star</v-icon>
      </div>
      <div class="fontColor" v-html="item.sectionContent"></div>
    </div>

    <div v-else>
      <h3 class="itemTitle headColor">{{ item.nameDE }}</h3>
      <!--                <v-list-item-title v-text="item.nameDE"></v-list-item-title>-->
      <div class="fontColor textFont">{{ item.descriptionDE }}</div>

      <div class="pt-1 d-flex" v-if="item.sizes" style="justify-content: flex-end">
        <template v-if="fordrinks">
          <div>
            <div v-if="hasReplaceArticle">
              <div class="fontColor maxw text-right"> {{ item | basePrice }}</div>
            </div>
            <div v-else class="d-flex" style="line-height: 1.5em" v-for="size in item.sizes">
              <div class="fontColor itemSubtitle mr-2 text-no-wrap" v-if="size.vol">{{ size.vol }}</div>
              <div class="fontColor maxw text-right" v-if="!$store.getters.hidePrices">{{ size.price | price(true) }}</div>
            </div>
          </div>
        </template>
        <template v-else>
          <div v-if="!$store.getters.hidePrices">
            <div v-if="hasReplaceArticle">
              <div class="fontColor maxw text-right"> {{ item | basePrice }}</div>
            </div>
            <div v-else class="fontColor"> {{ item.sizes[0].price | price(true) }}</div>
          </div>
        </template>
        <v-icon class="myAccent">mdi-chevron-right</v-icon>

      </div>
    </div>


  </div>

  <!--    Original Zeile eines Produktes von jetztessen.de-->
  <!--    <div class="itemsRow">-->
  <!--        <v-list-item-->
  <!--                :key="item.id"-->
  <!--                @click=""-->
  <!--        >-->
  <!--            <v-list-item-avatar tile :size="90">-->
  <!--                <v-img :src="imgSource"></v-img>-->
  <!--            </v-list-item-avatar>-->

  <!--            <v-list-item-content>-->
  <!--                <v-list-item-title v-text="item.nameDE"></v-list-item-title>-->
  <!--&lt;!&ndash;                <h3 class="text-none">{{item.nameDE}}</h3>&ndash;&gt;-->
  <!--                &lt;!&ndash;                <v-list-item-title v-text="news.title"></v-list-item-title>&ndash;&gt;-->
  <!--                <v-list-item-subtitle>{{item.descriptionDE}}</v-list-item-subtitle>-->
  <!--            </v-list-item-content>-->

  <!--            <v-list-item-action>-->
  <!--&lt;!&ndash;                <v-btn icon>&ndash;&gt;-->
  <!--                    <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>-->
  <!--&lt;!&ndash;                </v-btn>&ndash;&gt;-->
  <!--            </v-list-item-action>-->

  <!--&lt;!&ndash;                    <v-list-item-icon>&ndash;&gt;-->
  <!--&lt;!&ndash;                        <v-icon>mdi-heart</v-icon>&ndash;&gt;-->
  <!--&lt;!&ndash;                    </v-list-item-icon>&ndash;&gt;-->
  <!--        </v-list-item>-->
  <!--        <v-divider></v-divider>-->
  <!--    </div>-->
</template>

<script>
// import store from '../store/store'
// import {displayDate} from "@/vendor/util";
import * as itemUtil from '../vendor/itemUtil'

export default {
  props: {
    item: {
      type: Object,
    },
    fordrinks: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({}),
  computed: {
    hasReplaceArticle() {
      return !!itemUtil.findReplaceArticleStep(this.item);
    },
    imgSource() {
      let src = '';

      if (this.item.image && this.item.image.length > 0) {
        src = this.item.image;
      } else {
        // src = require('@/assets/placeholder6.jpg');
      }


      return src;
    },
    // hasDeepLink() {
    //     let link = this.news.link;
    //     return (link && link.indexOf('#') !== -1);
    // }
  },
  activated() {
    // this.init();
  },
  methods: {
    // init() {
    // },
  }
}
</script>

<style scoped lang="scss">
@import '../styles/base';

.isection {
  padding: 25px 0;
  line-height: 1.1;

  h2 {
    padding-top: 25px;
  }

  .prefix {
    padding-top: 1px;
    padding-right: 5px;
  }
}

.itemsRow {
  margin: 20px 0;
}

//remove the hover effect
/*.itemsRow {*/
/*    background-color: transparent;*/
/*}*/

.itemsRow:hover {
  color: $accent !important;
}

/*.isection ::v-deep b {*/
/*    font-weight: 700;*/
/*}*/

/*.itemsRow ::v-deep .v-list-item__title {*/
/*    font-size: 1em;*/
/*    font-weight: 700;*/
/*}*/

/*.itemsRow ::v-deep .v-btn__content {*/
/*    font-size: 1.2rem;*/
/*}*/

/*.itemsRow ::v-deep .headline {*/
/*    letter-spacing: 0.070rem !important;*/
/*}*/

/*.itemsRow ::v-deep .v-card__actions {*/
/*    position: absolute;*/
/*    bottom: 0;*/
/*    left: 0;*/
/*    width: 100%;*/
/*    padding-bottom: 0;*/
/*}*/

/*.itemsRow ::v-deep .v-icon {*/
/*    font-size: 25px;*/
/*}*/


</style>
